import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/tree';
import {TagRuleService} from "../../../services/tag/tag-rule.service";
import {StorageService} from "../../../services/storage.service";
import {TagService} from "../../../services/tag/tag.service";
import {TagTypeService} from "../../../services/tag/tag-type.service";

@Component({
  selector: 'pi-tag-selector',
  templateUrl: './tag-selector.component.html',
  styleUrls: ['./tag-selector.component.css']
})
export class TagSelectorComponent implements OnInit, OnChanges {
  @Input() uid;
  @Input() selectedTagType: any;
  @Output() selectedTagTypeChange = new EventEmitter<any>();
  @Input() categoryLimitation: string;
  @Output() onTypeSelected = new EventEmitter<any>();
  @Output() onTagFetched = new EventEmitter<any>();
  @Input() rememberType = true;
  tags: any[];
  tagTypes: any[];
    nodesSelections = [];

    tagSelections: any[] = [];
  typeCounts: any = {};

    constructor(
        private tagRuleService: TagRuleService,
        private tagTypeService: TagTypeService,
        private storageService: StorageService,
        private tagService: TagService
  ) {
    }

    ngOnInit() {
      this.loadData();
      this.getTagCounts();
    }

    async ngOnChanges(changes: SimpleChanges) {
      if (!this.tags) {
        await this.loadData();
      }

      if (changes.selectedTagType) {
        this.onTagTypeSelected();
      } else {
        if (this.rememberType) {
          const selectedTagType = this.storageService.getLocalItem('tagTypeSelector_' + (this.uid || 'default'));
          if (selectedTagType) {
            this.selectedTagType = selectedTagType;
          }
          this.onTagTypeSelected();
        }
      }
    }

    async onTagTypeSelected() {
    if (this.selectedTagType) {
      if (this.rememberType) {
        this.storageService.setLocalItem('tagTypeSelector_' + (this.uid || 'default'), this.selectedTagType);
      }
      this.onTypeSelected.emit(this.selectedTagType);
      this.tags = await this.tagService.getTagByTypeCode(this.selectedTagType).toPromise();
      this.onTagFetched.emit(this.tags);
    } else {
      this.onTypeSelected.emit(null);
    }
  }

  checkTagGroup() {
    const nodes = [];
    this.tagTypes.forEach(d => {
      nodes.push({
        title: d.tagTypeName,
        key: d.tagTypeCode,
        id: d.id,
        metaData: d,
        expanded: true,
        children: []
      })
    });
    this.nodesSelections = this.buildTree(nodes);
  }

  buildTree(list) {
    const map = {};
    let node;
    const roots = [];
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.metaData.parentId !== -1 && list[map[node.metaData.parentId]]) {
        // if you have dangling branches check that map[node.parentId] exists
        list[map[node.metaData.parentId]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    const endTime = new Date().getTime();
    return roots;
  }

  openFolder(data: NzTreeNode | NzFormatEmitEvent): void {
    // do something if u want
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
  }

  async getTagCounts() {
    this.typeCounts = await this.tagTypeService.getTagCounts().toPromise();
  }

  async loadData() {
    this.tagTypes = await this.tagTypeService.searchData({}).toPromise();
    if (this.categoryLimitation) {
      this.tagTypes = this.tagTypes.filter(t => t.tagCategoryCode === this.categoryLimitation);
    }
    if (this.selectedTagType) {
      try {
        this.tags = await this.tagService.getTagByTypeCode(this.selectedTagType).toPromise();
      } catch (e) {
        console.log(e);
        this.tags = [];
      }
    }
    this.checkTagGroup();
  }

  getSelections() {
    return this.tagSelections;
  }

  // getChildItem(groupId) {
  //   const tagGroupSelections = this.tagGroupList.filter(tg => tg.parentId === groupId);
  //   let childSelections = [];
  //   tagGroupSelections.forEach(tg => {
  //     childSelections = childSelections.concat(this.getChildItem(tg.id));
  //   });
  //   return tagGroupSelections.concat(childSelections);
  // }

}
